<template>
  <div class="container-fluid kv__slider">
    <div class="row">
      <div class="col-md-12">
        <h2 class="intro mt-5 mb-4" v-html="$t('kv.intro')"></h2>
      </div>
    </div>
    <div class="row kv">
      <div class="col-md-6 kv s5yw">
        <div class="kv__info">
          <img class="mt-4 img-fluid emblem" src="@/assets/images/5YW_logo.png" alt="">
          <div class="mt-4">
            <a v-html="$t('kv.link5yw')" class="register-btn" href="https://amica-group.bg/5yearwarranty" target="_blank" rel="noopener noreferrer"></a>
          </div>
        </div>
      </div>
      
      <div class="col-md-6 kv s7yw">
        <div class="kv__info">
          <img class="mt-4 img-fluid emblem" src="@/assets/images/7YW_logo.png" alt="">
          <div class="mt-4">
            <a v-html="$t('kv.link7yw')" class="register-btn" href="https://amica-group.bg/7yearwarranty" target="_blank" rel="noopener noreferrer"></a>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'Kv'
  }
</script>

<style lang="scss" scoped>
  h2.intro {
      font-size: 28px;
      font-weight: 400;
      color: #fff;
      width: 100%;
      text-align:center;

      @media only screen and (max-width : 991px) {
        font-size: 34px;
      }
    }

  .kv__slider{
    border-bottom: 1px solid #eaeaea;
  }
  .s5yw {
    background: url('../../assets/images/Baner_5yw.png');

  }
  .s7yw {
    background: url('../../assets/images/Baner_7yw.png');
  }
  .kv {
    height: 578px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;

    @media only screen and (max-width : 768px) {
      // background: #f6f6f6;
      height: auto;
      padding-top: 30px;
      padding-bottom: 30px;
      text-align: center;
    }
    // @media only screen and (max-width : 991px) {
    // }

    .kv__info {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      margin-top: 120px;
      margin-left: calc((100vw / 12) / 2); // 1/2grid
      width: 100%;

      @media only screen and (max-width : 768px) {
        margin-top: 0px;
      }

      img.emblem {
        max-width: 260px;
      }
      
      h2 {
        font-size: 42px;
        font-weight: 700;
        color: #fff;

        @media only screen and (max-width : 991px) {
          font-size: 34px;
        }
      }

      h4 {
        font-size: 30px;
        color: #fff;

        @media only screen and (max-width : 991px) {
          font-size: 24px;
        }
      }

      a.register-btn {
        background: #fff;
        border-radius: 99px;
        color: #e41429;
        font-size: 16px;
        font-weight: 400;
        padding: 10px 40px;
        display: inline-block;
        text-align: center; 
        
        &:hover {
          background: darken(#fff, 10%);
          text-decoration: none;
        }
      }
    }
  }
</style>
